import { useCallback, useRef, useState } from 'react';

export const useRxLabelState = (keepStateIfEmpty = false) => {
  const [labelActive, setLabelActive] = useState(false);
  const labelRef = useRef(null);

  const handleFocusChange = useCallback((event) => {
    if (event.type === 'focus') {
      setLabelActive(true);
    } else if (event.type === 'blur' && !event.target.value) {
      setLabelActive(false);
    }
  }, []);

  const handleValueChange = useCallback((event) => {
    const labelFocused = document.activeElement === labelRef.current;
    if (event.target.value) {
      setLabelActive(true);
    } else if (!labelFocused && !keepStateIfEmpty) {
      setLabelActive(false);
    }
  }, [keepStateIfEmpty]);

  return {
    labelActive,
    labelRef,
    handleFocusChange,
    handleValueChange,
  };
};
